import { useNavigation } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import { cn } from '@sunfish/lib/utils';

export function NavigationProgress() {
	const navigation = useNavigation();
	const isNavigating = navigation.state !== 'idle';

	const [progress, setProgress] = useState(0);
	const [visible, setVisible] = useState(false);
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

	useEffect(() => {
		if (isNavigating) {
			setVisible(true);
			setProgress(0);

			// Simulate progress - starts fast, slows down as it approaches 90%
			let currentProgress = 0;
			intervalRef.current = setInterval(() => {
				currentProgress += (90 - currentProgress) * 0.1;
				setProgress(Math.min(currentProgress, 90));
			}, 100);
		} else {
			// Complete the progress bar
			if (visible) {
				setProgress(100);
				const timeout = setTimeout(() => {
					setVisible(false);
					setProgress(0);
				}, 200);
				return () => clearTimeout(timeout);
			}
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [isNavigating, visible]);

	if (!visible) {
		return null;
	}

	return (
		<div className={cn('fixed top-0 left-0 right-0 z-50 h-[3px] bg-transparent', 'pointer-events-none')}>
			<div
				className={cn(
					'h-full bg-amber-500 transition-all duration-200 ease-out',
					'shadow-[0_0_10px_rgba(245,158,11,0.7),0_0_4px_rgba(245,158,11,0.9)]',
					progress === 100 && 'opacity-0 transition-opacity duration-200'
				)}
				style={{ width: `${progress}%` }}
			/>
		</div>
	);
}
